module.exports = __webpack_public_path__ + "static/media/ready_to_party.60bccbe4.svg";